'use client';

import { c as _c } from "react/compiler-runtime";
import { usePathname } from 'next/navigation';
import type { BuyItAgainGuestPlacement } from '@libs/common-types';
import { type OptexBiaGuestProduct, useOptexBiaGuest } from '../../../../hooks';
const OPTEX_SEARCH_BIA_GUEST_CALLER = 'web:searchbar:bia-guest';
export type OptexSearchBiaGuestProduct = Omit<OptexBiaGuestProduct, 'hit'>;
export function getOptexSearchBiaGuestPlacement(pathname: string): BuyItAgainGuestPlacement {
  return /(?:^|\/)cart\/?$/.test(pathname) ? 'incart' : 'homepage';
}
export function useOptexSearchBiaGuest(isOptexSearchBiaGuestEnabled) {
  const $ = _c(5);
  const optexPathname = usePathname() ?? "";
  let t0;
  if ($[0] !== optexPathname) {
    t0 = getOptexSearchBiaGuestPlacement(optexPathname);
    $[0] = optexPathname;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  const optexPlacement = t0;
  let t1;
  if ($[2] !== isOptexSearchBiaGuestEnabled || $[3] !== optexPlacement) {
    t1 = {
      optexEnabled: isOptexSearchBiaGuestEnabled,
      optexPlacement,
      optexCaller: OPTEX_SEARCH_BIA_GUEST_CALLER
    };
    $[2] = isOptexSearchBiaGuestEnabled;
    $[3] = optexPlacement;
    $[4] = t1;
  } else {
    t1 = $[4];
  }
  return useOptexBiaGuest(t1);
}